import { AxiosResponse } from 'axios';
import { put } from 'redux-saga/effects';
import { api } from '../../libs';
import { loginError } from '../actions/auth';
import {
  fetchReviewsSuccess,
  IReviewRemoveRequestAction,
  IReviewsFetchRequestAction,
  reviewsError,
} from '../actions/reviews';
import { IReview } from '../types/review';

export function* fetchReviewsSaga(action: IReviewsFetchRequestAction) {
  try {
    const response: AxiosResponse = yield api.reviews.getAllReviews(action.payload);

    const fetchedReviews: IReview[] = response.data.reviews;
    yield put(fetchReviewsSuccess(fetchedReviews, response.data.page_info));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(reviewsError(err.message));
    }
  }
}

export function* removeReviewSaga(action: IReviewRemoveRequestAction) {
  try {
    yield api.reviews.remove(action.payload.id);
    if (action.payload.onSuccess) {
      yield put(action.payload.onSuccess());
    }
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(reviewsError(err.message));
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/reviews.ts